/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  GET_ORDER_DASHBOARD: "/api/customer/get_dashboard_data",
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

export const get_dashboard_index_data = createAsyncThunk(
  "dashboard/get_dashboard_index_data",
  async (customerId, { rejectWithValue, fulfillWithValue }) => {
    // console.log('customerId :>> ', customerId);

    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_ORDER_DASHBOARD}/${customerId}`,
      );
      // console.log('api response getting dashboard data', data);
      return fulfillWithValue(data);
    } catch (error) {
      console.log("error getting dashboard data", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Reducer principal
export const dashboardReducer = createSlice({
  name: "dashboard",
  initialState: {
    successMessage: "",
    messageError: "",
    loading: false,
    recentOrders: [],
    totalOrder: 0,
    pendingOrder: 0,
    cancelledOrder: 0,
  },
  reducers: {
    setDashboardInfo: (state, action) => {
      state.dashboardInfo = action.payload;
    },
    messageClear: (state) => {
      state.messageError = "";
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(get_dashboard_index_data.pending, (state) => {
        state.loading = true;
        state.messageError = "";
      })
      .addCase(get_dashboard_index_data.fulfilled, (state, action) => {
        state.loading = false;
        state.recentOrders = action.payload.recentOrder;
        state.totalOrder = action.payload.totalOrder;
        state.pendingOrder = action.payload.pendingOrder;
        state.cancelledOrder = action.payload.cancelledOrder;
      })
      .addCase(get_dashboard_index_data.rejected, (state, action) => {
        state.loading = false;
        state.messageError = action.payload;
      });
  },
});

export const { setDashboardInfo, messageClear } = dashboardReducer.actions;
export default dashboardReducer.reducer;
